package top.wcpe.allincore.dsl.compiler.codegen

import top.wcpe.allincore.dsl.compiler.ast.PapiBlockAst
import top.wcpe.allincore.dsl.compiler.codegen.internal.ExprSerializer
import top.wcpe.allincore.dsl.compiler.pipeline.PlaceholderRegistry
import top.wcpe.allincore.dsl.compiler.pipeline.PlaceholderResolution
import top.wcpe.allincore.dsl.ir.model.UiPlaceholderBlock

/** Stage4：PAPI AST 到 IR 占位符半成品映射。 */
class PapiEmitter(
    private val registry: PlaceholderRegistry? = null,
) {
    companion object {
        private const val DEFAULT_REFRESH_MS = 1000L
    }

    fun emit(blocks: List<PapiBlockAst>): Map<String, UiPlaceholderBlock> {
        val out = LinkedHashMap<String, UiPlaceholderBlock>()
        for (block in blocks) {
            for (placeholder in block.placeholders) {
                val resolution = resolve(placeholder.shortName)
                val refreshMs = placeholder.refreshMs
                    ?: resolution?.refreshMs
                    ?: registry?.defaults?.refreshMs
                    ?: DEFAULT_REFRESH_MS
                // putIfAbsent 为 JVM 扩展；common 等价写法（返回值本就未使用，FR-UI-061 中立化）
                if (placeholder.shortName !in out) {
                    out[placeholder.shortName] = UiPlaceholderBlock(
                        placeholder.shortName,
                        refreshMs,
                        placeholder.bindState,
                        placeholder.pipe?.let { ExprSerializer.serializeExpr(it) },
                        placeholder.onChange,
                        resolution?.let { it.allowed && !it.denied } ?: false,
                    )
                }
            }
        }
        return out
    }

    private fun resolve(shortName: String): PlaceholderResolution? =
        registry?.resolveAllow("%$shortName%")
}
